import type { ComponentPropertyBindingType } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

/**
 * Returns whether or not the binding direction type is considered "private",
 * so that can only be read or written inside the composite component.
 * @param bindingType binding direction type
 * @returns whether or not the type is considered "private"
 */
export default function isPrivateBindingType(
  bindingType: ComponentPropertyBindingType | null | undefined,
): bindingType is 'private' | 'private-data' | 'data-interface' {
  switch (bindingType) {
    case 'private':
    case 'private-data':
    case 'data-interface':
      return true;
    default:
      return false;
  }
}
